











import { Component, Prop, Vue } from "vue-property-decorator";
import { GetLocationsResponse } from "../../apis/model/get-locations-response";
import { LocationsApi } from "../../apis/invoke/locations-api";
@Component({})
export default class AppButtonSaveChange extends Vue {
  getRouteLocationDetail() {
    return this.$router.push("/customers/locations/location-detail/:id");
  }
}
